import { Alert, Loader, MantineProvider } from '@mantine/core';
import { BrowserRouter, Route, Routes, useParams, useSearchParams } from 'react-router-dom';
import '@mantine/core/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPrint, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { AppErrorBoundary } from '../../components/BaseErrorBoundary';
import { Button } from '../../components/Button';
import { PickListModal } from '../../components/PickListModal/PickListModal';
import { AttendanceSlip } from '../PosShellPage/components/attendance/AttendanceSlip';
import { EmployeeIdentificationGate } from '../PosShellPage/components/auth/EmployeeIdentificationGate';
import { usePublicAttendanceController } from './usePublicAttendanceController';
import classes from './public-attendance.module.scss';

export function PublicAttendancePage() {
  const { tenantId = '' } = useParams();
  const [query] = useSearchParams();
  const state = usePublicAttendanceController(tenantId, query.get('key') ?? '');
  return <main dir="rtl" className={classes.page}>
    <div className={classes.content}>
    <header className={classes.header}>
      <div className={classes.brand}>COMMIT AI</div>
      <h1>נוכחות</h1>
      <p>כניסה ויציאה ממשמרת</p>
    </header>
    <div className={classes.feedback}>
    {state.loading && !state.available && <Loader aria-label="טוען עובדים" />}
    {state.error && <Alert color="red">{state.error}{!state.slip && <Button variant="icon" onClick={state.refresh} disabled={state.loading} ariaLabel="נסה שוב"><FontAwesomeIcon icon={faRotateRight as IconProp} /></Button>}</Alert>}
    {state.notice && <Alert color="green">{state.notice}</Alert>}
    </div>
    {!state.slip && <EmployeeIdentificationGate attendanceOnly attendanceUiEnabled={state.available} employees={[]}
      attendanceEmployees={state.employees} isLoadingEmployees={state.loading} isIdentifying={false}
      error={state.error || null} onIdentify={async () => false} onRefresh={state.refresh} onClearError={state.clearError}
      onAttendanceAction={state.clock} isAttendanceActioning={state.busy}
      onResolveAttendanceShiftStatus={state.status} onEmployeeReportRequired={state.reportRequired}
      attendancePickerFooter={state.hasMore ? <Button variant="save" onClick={state.loadMore} loading={state.loading}>טען עוד עובדים</Button> : undefined} />}
    {state.slip && <section className={classes.receipt} aria-label="אישור נוכחות">
      <AttendanceSlip action={state.slip} />
      <div className={classes.receiptActions}>
        <Button variant="confirm" ariaLabel="הדפס אישור" onClick={() => state.printSlip()} loading={state.printing}><FontAwesomeIcon icon={faPrint as IconProp} /> הדפס אישור</Button>
        <Button variant="cancel" onClick={state.closeSlip} disabled={state.printing}><FontAwesomeIcon icon={faCheck as IconProp} /> סיום</Button>
      </div>
    </section>}
    <PickListModal title="בחר מדפסת" options={state.printers} disabled={state.printing}
      dataTestId="public-attendance-printer-pick" onPick={(printerId) => { void state.printSlip(printerId); }} onClose={state.closePrinterPicker} />
    <div className={classes.capture} aria-hidden="true">
      {state.slip && <AttendanceSlip action={state.slip} innerRef={state.slipRef} suppressTestIds />}
    </div>
    </div>
  </main>;
}

export function PublicAttendanceEntry() {
  return <MantineProvider defaultColorScheme="light"><AppErrorBoundary><BrowserRouter><Routes>
    <Route path="/attendance/:tenantId" element={<PublicAttendancePage />} />
    <Route path="*" element={<main dir="rtl"><h1>הנוכחות אינה זמינה כרגע</h1></main>} />
  </Routes></BrowserRouter></AppErrorBoundary></MantineProvider>;
}